import React from 'react';
import { Card, CardContent, Typography, Switch } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import ComponentHeaderTitles from '../ComponentHeaderTitles';
import { createTheme, ThemeProvider } from '@mui/material/styles';


const theme = createTheme({
    palette: {
        // Voorbeeld van het aanpassen van de primaire kleur
        primary: {
            main: '#4D0985', // een specifieke kleurtint, in dit geval roze
        },
    },
});

/**
 *
 * @file This file contains the ExtraOptions component.
 * @description This component is responsible for rendering the ExtraOptions component.
 * If the user has chosen 'Electriciteit' as their product,
 * we want to show the user some extra options.
 * If the user has not chosen 'Electriciteit', we want to hide the extra options.
 * The slimmeMeter option is always shown, and is required to be checked to continue.
 *
 * @param {*} props - The component props.
 * @param {boolean} props.electricCarWithCharger - Whether the user has an electric car with charger.
 * @param {Array} props.chosenProduct - An array of chosen products (e.g. "Electriciteit", "Gas").
 * @param {Function} props.setElectricCarWithCharger - A function to set the electricCarWithCharger state.
 * @param {boolean} props.warmtepomp - Whether the user has a warmtepomp.
 * @param {Function} props.setWarmtepomp - A function to set the warmtepomp state.
 * @param {boolean} props.slimmeMeter - Whether the user has a slimme meter.
 * @param {Function} props.setSlimmeMeter - A function to set the slimmeMeter state.
 * @returns {JSX.Element} The rendered component.
 * @exports ExtraOptions
 */


const ExtraOptions = ({ electricCarWithCharger, chosenProduct, setElectricCarWithCharger, warmtepomp, setWarmtepomp, slimmeMeter, setSlimmeMeter }) => {
    // Check if 'Electriciteit' is present in chosenProduct array
    const hasElectricity = chosenProduct.includes("Electriciteit");

    /**
     * Effect to run on component mount and whenever hasElectricity changes
     * If the user does not require electricity,
     * we want to reset the electricCarWithCharger and warmtepomp states
     */
    React.useEffect(() => {
        if (!hasElectricity) {
            setElectricCarWithCharger(false);
            setWarmtepomp(false);
        }
    }, [hasElectricity, setElectricCarWithCharger, setWarmtepomp]);


    const handleElectricCarChange = (event) => {
        setElectricCarWithCharger(event.target.checked);
        console.log(chosenProduct);
    };

    const handleWarmtepompChange = (event) => {
        setWarmtepomp(event.target.checked);

    };

    const handleSlimmeMeterChange = (event) => {
        setSlimmeMeter(event.target.checked);
    }


    return (
        <div className="extra-options">
            <ComponentHeaderTitles title="Heb je beschikking over de volgende zaken?" />
<div className="SwitchQuestionContainer">
                    <div className="switchQuestion slimme-meter-question">
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={slimmeMeter}
                                    onChange={handleSlimmeMeterChange}
                                    name="slimmeMeter"
                                    color="primary"
                                    required
                                    className="switchLabel"
                                />
                            }
                            label="Slimme meter"
                            className="switchLabel"
                        />
                    </div>
                    {hasElectricity && (
                        <>
                            <div className="switchQuestion electric-car-with-charger-question">
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={electricCarWithCharger}
                                            onChange={handleElectricCarChange}
                                            name="electricCarWithCharger"
                                            className="switchLabel"
                                        />
                                    }
                                    label="Laadpaal"
                                    className="switchLabel"
                                />
                            </div>
                            <div className="switchQuestion warmtepomp-question">
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={warmtepomp}
                                            onChange={handleWarmtepompChange}
                                            name="warmtepomp"
                                            className="switchLabel"
                                        />
                                    }
                                    label="Warmtepomp"
                                    className="switchLabel"
                                />
                            </div>
                        </>
                    )}
</div>
        </div>
    );
};

ExtraOptions.displayName = 'ExtraOptions';
export default ExtraOptions;
